
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[pillar]/blog/[slug]",
      function () {
        return require("private-next-pages/[pillar]/blog/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[pillar]/blog/[slug]"])
      });
    }
  